import { render, staticRenderFns } from "./NetworkReportCard_EIBIC.vue?vue&type=template&id=96450b08&"
import script from "./NetworkReportCard_EIBIC.vue?vue&type=script&lang=js&"
export * from "./NetworkReportCard_EIBIC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports